import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import {  baseUrl } from "../utils/OtherUtils";

const ResetPassword = () => {
  const { resetToken } = useParams();  // Access the reset token from URL params
  const navigate = useNavigate();  // For programmatic navigation after form submission
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword) {
      setError('Password is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${baseUrl}/auth/reset-password/${resetToken}`, {
        newPassword ,  // Sending the new password to the server
      });
      if (response?.data?.success){
        navigate('/')
      }
     
    } catch (err) {
      setError('An error occurred, please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen  bg-gray-50">
      <div className="w-full max-w-md p-6 flex-col items-center h-[270px] bg-white rounded-[40px] shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Reset Your Password</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-600">New Password:</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              placeholder="Enter your new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-2 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:[#0047AF]"
              required
            />
          </div>

          {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

          <button 
            type="submit" 
            className={`w-full py-2 mt-4 text-white font-semibold rounded-[48px] ${loading ? 'bg-gray-400' : 'bg-gradient-to-r from-[#1A67D8] to-[#0047AF]'}`} 
            disabled={loading}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
